/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaEventoAggiornamentoDTO { 
    id?: string;
    actor_type?: ServizioMensaEventoAggiornamentoDTOActorTypeEnum;
    data_operazione?: string;
    operazione?: string;
}
export enum ServizioMensaEventoAggiornamentoDTOActorTypeEnum {
    CITTADINO = 'CITTADINO',
    OPERATORE = 'OPERATORE',
    SISTEMA = 'SISTEMA',
    ESTERNO = 'ESTERNO',
    CASSIERE = 'CASSIERE',
    ESERCENTE = 'ESERCENTE'
};



